import {IConfig} from "./IConfig";

export const Config: IConfig = {
    apiUrl: `${process.env.REACT_APP_API_URL}`,
    cdnBaseUrl: `${process.env.REACT_APP_CDN_BASE_URL}`,
    googleMapsKey: `${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`
};
